import { autoserialize } from 'cerialize';

import { DonationSource } from './donation-source';
import { SurveyTrigger } from './survey';

export class DonationMeta {
  @autoserialize source?: DonationSource;
  @autoserialize declinedExtraMile?: boolean;
  @autoserialize design?: string;
  @autoserialize manualAddress: boolean;
  @autoserialize requestCancel: boolean;
  @autoserialize etaProvidedAt?: string;
  @autoserialize etaRequestedAt?: string;
  @autoserialize smsApproval?: boolean;
  @autoserialize marketingRule?: string;
  @autoserialize marketingVariation?: string;
  @autoserialize flowRule?: string;
  @autoserialize flowVariation?: string;
  @autoserialize geofence?: 'soft' | 'hard';
  @autoserialize donatableSmall?: number;
  @autoserialize nonDonatableSmall?: number;
  @autoserialize captchaScore?: number;
  @autoserialize staircasesStepSubmitted?: boolean;
  @autoserialize newCaptainLeadForm?: boolean;
  @autoserialize newCaptainLeadFormStep?: number;
  @autoserialize charityChangeReason?: string;
  @autoserialize surveys?: string;
  @autoserialize verificationPhoto?: string;
  @autoserialize verificationPhotoDateTime?: string;

  constructor(payload?: IDonationMeta | null) {
    this.source = payload?.source;
    this.declinedExtraMile = payload?.declinedExtraMile;
    this.design = payload?.design;
    this.manualAddress = !!payload?.manualAddress;
    this.requestCancel = !!payload?.requestCancel;
    this.etaProvidedAt = payload?.etaProvidedAt;
    this.etaRequestedAt = payload?.etaRequestedAt;
    this.smsApproval = payload?.smsApproval;
    this.marketingRule = payload?.marketingRule;
    this.marketingVariation = payload?.marketingVariation;
    this.flowRule = payload?.flowRule;
    this.flowVariation = payload?.flowVariation;
    this.geofence = payload?.geofence;
    this.donatableSmall = payload?.donatableSmall;
    this.nonDonatableSmall = payload?.nonDonatableSmall;
    this.captchaScore = payload?.captchaScore;
    this.staircasesStepSubmitted = payload?.staircasesStepSubmitted;
    this.newCaptainLeadForm = payload?.newCaptainLeadForm;
    this.newCaptainLeadFormStep = payload?.newCaptainLeadFormStep || 0;
    this.charityChangeReason = payload?.charityChangeReason;
    this.surveys = payload?.surveys;
    this.verificationPhoto = payload?.verificationPhoto;
    this.verificationPhotoDateTime = payload?.verificationPhotoDateTime;
  }

  get completedSurveys(): SurveyTrigger[] {
    return (this.surveys || '').split(',') as SurveyTrigger[];
  }

  set completedSurveys(triggers: SurveyTrigger[]) {
    this.surveys = triggers.join(',');
  }
}

export interface IDonationMeta {
  source?: DonationSource;
  declinedExtraMile?: boolean;
  design?: string;
  manualAddress?: boolean;
  requestCancel?: boolean;
  etaProvidedAt?: string;
  etaRequestedAt?: string;
  smsApproval?: boolean;
  marketingRule?: string;
  marketingVariation?: string;
  flowRule?: string;
  flowVariation?: string;
  geofence?: 'soft' | 'hard';
  donatableSmall?: number;
  nonDonatableSmall?: number;
  captchaScore?: number;
  staircasesStepSubmitted?: boolean;
  newCaptainLeadForm?: boolean;
  newCaptainLeadFormStep?: number;
  charityChangeReason?: string;
  surveys?: string;
  verificationPhoto?: string;
  verificationPhotoDateTime?: string;
}
